import React, { useState } from 'react';
import { LuCircleCheck, LuPencil, LuTrash2 } from 'react-icons/lu';

// Respuesta del admin a un renglón que la empresa no reconoce (15-oct-2026):
//   "Lo hice, está bien" (con una explicación que la empresa ve en su portal),
//   "Corregir" (abre el trabajo para editarlo) o "Sacar" (era un error: sale del resumen).
const ETIQUETA = { OK: 'Respondiste', CORREGIDO: 'Lo corregiste', QUITADO: 'Lo sacaste' };

export default function RespuestaObservado({ respuesta, onResponder, onCorregir }) {
    const [modo, setModo] = useState(null);      // null | 'OK' | 'QUITADO'
    const [texto, setTexto] = useState('');
    const [enviando, setEnviando] = useState(false);
    const enviar = async (tipo, t = texto) => {
        setEnviando(true);
        try { await onResponder(tipo, t.trim() || null); setModo(null); setTexto(''); }
        finally { setEnviando(false); }
    };

    if (respuesta && !modo) {
        return (
            <div className="mt-1.5 flex items-start gap-1.5 text-label">
                <LuCircleCheck size={13} className="mt-px shrink-0 text-[#16A34A]" />
                <p className="flex-1 min-w-0 text-secondary"><b className="text-ink">{ETIQUETA[respuesta.tipo] || 'Respondiste'}</b>{respuesta.texto ? `: ${respuesta.texto}` : ''}</p>
                {respuesta.tipo === 'OK' && <button type="button" onClick={() => { setModo('OK'); setTexto(respuesta.texto || ''); }} className="shrink-0 font-black text-secondary underline">Cambiar</button>}
            </div>
        );
    }
    if (modo) {
        const sacar = modo === 'QUITADO';
        return (
            <div className="mt-2 space-y-1.5" onClick={e => e.stopPropagation()}>
                <textarea rows={2} value={texto} onChange={e => setTexto(e.target.value)} autoFocus
                    placeholder={sacar ? 'Por qué se saca (opcional): se cargó de más, era de otro cliente…' : 'Qué se hizo, para la empresa: "Se cambió la canilla, ver fotos"'}
                    className="w-full px-3 py-2 rounded-lg bg-card text-caption text-ink outline-none resize-none placeholder:text-muted" />
                <div className="flex gap-1.5">
                    <button type="button" onClick={() => setModo(null)} className="flex-1 h-9 rounded-lg bg-chip text-label font-black text-secondary">Cancelar</button>
                    <button type="button" disabled={enviando || (!sacar && !texto.trim())} onClick={() => enviar(modo)}
                        className={`flex-[2] h-9 rounded-lg text-label font-black text-white disabled:opacity-40 ${sacar ? 'bg-brand-red' : 'bg-[#16A34A]'}`}>
                        {enviando ? 'Guardando…' : sacar ? 'Sí, sacarlo del resumen' : 'Enviar a la empresa'}
                    </button>
                </div>
                {sacar && <p className="text-label text-muted">El trabajo se archiva (no se borra) y deja de sumar en el mes.</p>}
            </div>
        );
    }
    const btn = 'flex-1 h-8 rounded-lg text-label font-black inline-flex items-center justify-center gap-1 active:scale-95';
    return (
        <div className="mt-2 flex gap-1.5" onClick={e => e.stopPropagation()}>
            <button type="button" onClick={() => setModo('OK')} className={`${btn} bg-[rgba(22,163,74,0.12)] text-[#16A34A]`}><LuCircleCheck size={13} /> Está bien</button>
            {onCorregir && <button type="button" disabled={enviando} onClick={async () => { await enviar('CORREGIDO', 'Lo corregimos'); onCorregir(); }} className={`${btn} bg-chip text-ink`}><LuPencil size={12} /> Corregir</button>}
            <button type="button" onClick={() => setModo('QUITADO')} className={`${btn} bg-chip text-brand-red`}><LuTrash2 size={12} /> Sacar</button>
        </div>
    );
}
